{
  "title": "My Profile",
  "fallbackName": "Explorer",
  "greeting": "Hello, {name}!",
  "actions": {
    "changeAvatar": "Change avatar",
    "selectAvatar": "Select avatar {id}"
  },
  "status": {
    "saving": "Saving...",
    "updating": "Updating..."
  },
  "errors": {
    "localeUpdateFailed": "Failed to update language. Please try again.",
    "avatarUpdateFailed": "Failed to update avatar. Please try again."
  },
  "tabs": {
    "likes": "Liked",
    "bookmarks": "Bookmarked"
  },
  "empty": {
    "likes": {
      "alt": "No liked questions yet",
      "message": "You haven't liked any questions yet."
    },
    "bookmarks": {
      "alt": "No bookmarked questions yet",
      "message": "You haven't bookmarked any questions yet."
    }
  },
  "modal": {
    "title": "Choose your avatar"
  }
}
